import AboutData from './AboutData';
import WhoShouldConsiderData from './WhoShouldConsiderData';
import PurchasingSteps from './PurchasingSteps';
import PolicyReviewInfo from './PolicyReviewInfo';
import VideoData from './VideoData'
import FaqData from './FaqData';

export default function PolicyData() {
  const minAge = 18;
  const maxAge = 80;
  const minCoverageAmount = 25000;
  const maxCoverageAmount = 10000000;

  return {
    name: 'Policy Review',
    subtitle: '',
    specs: {
      age: { min: minAge, max: maxAge },
      coverageAmount: { min: minCoverageAmount, max: maxCoverageAmount },
    },
    hyperlinks: [
      {
        title: 'ABOUT',
        link: '#about'

      },
      {
        title: 'WHO SHOULD CONSIDER',
        link: '#whoShouldConsider',
      },
      {
        title: 'WHAT IS A POLICY REVIEW',
        link: '#policyReviewInfo',
      },
      {
        title: 'FREQUENTLY ASKED QUESTIONS',
        link: '#faq',
      }
    ],
    video: VideoData(),
    about: AboutData(),
    whoShouldConsider: WhoShouldConsiderData(),
    PurchasingSteps: PurchasingSteps(),
    PolicyReviewInfo: PolicyReviewInfo(),
    faq:FaqData(),
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/data/policy-review/PolicyData.js